import { Box, Button } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NavLink as RouterLink } from 'react-router-dom';

const ToolbarActions = () => {
  const { t } = useTranslation('users');

  return (
    <Box display="flex" justifyContent="flex-end">
      <Button color="primary" variant="contained" component={RouterLink} to="/app/users/create">
        {t('buttons.users_list_create')}
      </Button>
    </Box>
  );
};

export default ToolbarActions;
